import { SnotifyToastConfig } from 'ng-snotify';

export const snotifyConfig: SnotifyToastConfig = {
  timeout: 0,
  showProgressBar: false,
  closeOnClick: false,
  pauseOnHover: false,
  position: 'centerCenter',
  backdrop: 0.3
};
